<template>
  <div class="carousel-video" v-loading="loadingImg" v-if="images.length > 0">
    <div class="box">
      <el-carousel arrow="never" :autoplay="false" :interval="5000" indicator-position="outside" trigger="click" :style="{ height: '250px'}">
        <el-carousel-item v-for="image in images" :key="image.keyDoc">
          <div class="video-name truncate">
            <span>{{ image.titolo.toUpperCase() }}</span>
          </div>
          <div class="video pointer">
            <video controls controlsList="nodownload" oncontextmenu="return false;">
              <source :src="image.link" type="video/mp4">
            </video>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    name: 'CarouselVideo',
    props: {
      contenitoreHeight: {
        type: Number
      },
      loadingImg: {
        required: true,
        type: Boolean,
        default: false
      },
      ['images']: {
        type: Array,
        required: true,
        default: []
      }
    },
    i18n: {
      messages: {
        it_IT: {
          carousel: {
            title: 'Info'
          }
        },
        fr_FR: {
          carousel: {
            title: 'Infos'
          }
        },
        es_ES: {
          carousel: {
            title: 'Info'
          }
        },
        en_GB: {
          carousel: {
            title: 'Infos'
          }
        },
        de_DE: {
          carousel: {
            title: 'Information'
          }
        }
      }
    },
    data () {
      return {
      }
    },
    computed: {
    },
    mounted: function () {
    },
    methods: {
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .carousel-video {
    height: 280px;
    // height: 100%;
    padding-bottom: 10px;
    .box {
      height: 280px;
      // height: 100%;
      overflow: auto;
      /*border: 1px solid #e7e7e7;
      border-radius: 4px;
      -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
      -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      box-shadow: 0px 0px 13px 1px #e7e7e7;*/
      padding: 10px;
      .titolo {
        width: 100%;
        .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
        text-align: left;
        line-height: 30px;
        height: 30px;
        letter-spacing: 2px;
      }
      .el-carousel {
        height: 100%;
        height: 250px;
        .el-carousel__container{
          height: 218px;
          .el-carousel__item {
            .video-name {
              width: 100%;
              .set-font(@color: #B03488, @size: 12px, @family: 'os-semibolditalic');
              text-align: right;
              line-height: 20px;
              height: 20px;
            }
            .video {
              video {
                width: 100%;
                height: 200px;
              }
            }
          }
        }
        .top-block {
          width: 100%;
          .set-font(@color: #B03488, @size: 12px, @family: 'os-semibolditalic');
          text-align: right;
          line-height: 20px;
          height: 20px;
        }
        .linkDetail {
          height: 40px;
          line-height: 30px;
          position: relative;
          padding-bottom: 10px;
          display: flex;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: lowercase;
          a {
          .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
          .applicazione {
            text-transform: uppercase;
            .set-font(@size: 14px, @color: #485eb5, @weight: bold, @family:'os-regular');
          }
          .url {
            text-transform: lowercase;
            .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
          }
          }
          a:hover {
            text-decoration: none;
          }
          a:focus {
            text-decoration: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/CarouselVideo.vue